import type { SaleCoupon } from '@src/domains/coupons/types/coupon';
import { getDiscountCurrencyInfo } from '@src/domains/coupons/core/getDiscountCurrencyInfo';

export const getCouponDiscountCurrencyInfo = (coupon: SaleCoupon) =>
  getDiscountCurrencyInfo(coupon.fullAmountCurrencyInfo, coupon.finalAmountCurrencyInfo);
